import React, {FunctionComponent, useContext, useMemo} from 'react';
import UITranslations from "../../store/uiTranslations";
import {IBuilding} from "../../types/IBuilding";
import Banner from "../ui/Banner/Banner";

import './WelcomeBanner.css';
import {isToday} from "../../utils/date";
import ReactMarkdown from "react-markdown";
import {Context} from "../../store/context";
import TranslatedText from "../ui/TranslatedText/TranslatedText";

interface IWelcomeBanner {
    building?:IBuilding;
}

const WelcomeBanner:FunctionComponent<IWelcomeBanner> = ({building}) => {
    const ui = UITranslations.PhotoRoutePage;
    const {languagesStore} = useContext(Context);
    const bannerText = useMemo(()=>{
        if(!building || !building.welcomeTextI18n)
            return undefined;

        const message = building.welcomeTextI18n[languagesStore.currentIETF];
        return message ? message.trim() : undefined;
    }, [building?.welcomeTextI18n, languagesStore.currentIETF]);

    if(!building?.showWelcomeText || !bannerText)
        return null;

    const localStorageKey = `welcomeBanner__${building.id}`;
    const localStorageItem = localStorage.getItem(localStorageKey);
    if(isToday(localStorageItem))
        return null;

    const handleBannerClose = () =>{
        localStorage.setItem(localStorageKey, new Date().toDateString());
    }

    return <Banner className="welcome-banner" onClose={handleBannerClose}>
        <h5 className="welcome-banner__header"><TranslatedText source={ui.WelcomeBanner.ImportantHeader}/></h5>
        <ReactMarkdown source={bannerText} />
    </Banner>
};

export default WelcomeBanner;
